import './ImageTile.scss';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import LinkedInIcon from '@mui/icons-material/LinkedIn';

const iconMap = {
  Facebook: <FacebookIcon color="primary" />,
  Linkedln: <LinkedInIcon color="primary" />,
  Twitter: <TwitterIcon color="primary" />,
};

export const ImageTile = ({ title, imageUrl, handleCheckboxChange, value = {}, id }) => {
  const titleWithoutExtension = title?.split('.');
  const selected = Object.values(value);
  const isSelected = selected && selected.includes(id);
  const imageBaseUrl = process.env.REACT_APP_EXTHUB_DOMAIN;
  return (
    <div
      id="image-tile-container"
      className={isSelected ? 'selected' : ''}
      onClick={handleCheckboxChange}
    >
      <div id={`checkbox-${id}`} className="image-tile">
        <label htmlFor="checkbox">
          <img src={`${imageBaseUrl}/api/cdn${imageUrl}`} alt="tile" />
        </label>
        {isSelected && (
          <div className="checkbox-overlay">
            {Object.keys(value)?.map((k) => {
              // console.log({isSelected, id, k, value})
              return isSelected && id === value[k] ? iconMap[k] : null;
            })}
            <input type="checkbox" checked={isSelected} onChange={() => {}} />
          </div>
        )}
      </div>
      <div className="image-tile-text">
        {' '}
        {titleWithoutExtension ? titleWithoutExtension[0] : ''}
      </div>
    </div>
  );
};
